import React from 'react';

import {Ref as CustomRunNamesRef} from '../../../state/views/customRunNames/types';
import {WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {RunRowHeaderMenu} from './RunRowHeaderMenu';

const spacer = (
  <div style={{height: 16, width: 16, flexGrow: 0, flexShrink: 0}} />
);

type RowHeaderMenuProps = {
  canBenchmarkRun: boolean;
  canStopRun: boolean;
  isHeaderDropdownEmpty: boolean;
  isGroup: boolean;
  onBenchmarkRun: () => void;
  onCopyRunName: () => void;
  onCopyRunPath: () => void;
  onDeleteRun: () => void;
  onMoveRun: () => void;
  onStopRun: () => void;
  row: WBTableRowWithRunSetInfo;
  customRunNamesRef: CustomRunNamesRef | undefined;
};

export function RowHeaderMenu({
  canBenchmarkRun,
  canStopRun,
  isHeaderDropdownEmpty,
  isGroup,
  onBenchmarkRun,
  onCopyRunName,
  onCopyRunPath,
  onDeleteRun,
  onMoveRun,
  onStopRun,
  row,
  customRunNamesRef,
}: RowHeaderMenuProps) {
  if (isHeaderDropdownEmpty) {
    return spacer;
  }
  if (!isGroup) {
    return (
      <RunRowHeaderMenu
        row={row}
        customRunNamesRef={customRunNamesRef}
        onBenchmarkRun={onBenchmarkRun}
        onCopyRunName={onCopyRunName}
        onCopyRunPath={onCopyRunPath}
        onDeleteRun={onDeleteRun}
        onMoveRun={onMoveRun}
        onStopRun={onStopRun}
        canBenchmarkRun={canBenchmarkRun}
        canStopRun={canStopRun}
      />
    );
  }

  return spacer;
}
